import React from 'react';

import PropTypes from 'prop-types';

const DAY_NAME_STYLES =
  'px-3 py-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground';

const HeaderCell = ({ dayName }) => <div className={DAY_NAME_STYLES}>{dayName}</div>;

HeaderCell.propTypes = {
  dayName: PropTypes.string.isRequired,
};

export default HeaderCell;
